<template>
    <div>
        <!-- 封禁表单 -->
        <el-form :model="platForm" status-icon :rules="rules" ref="platForm" label-width="100px">
            <el-form-item label="封禁方式">
                <el-radio-group v-model="platForm.permanent">
                    <el-radio :label="false">按时长封禁</el-radio>
                    <el-radio :label="true">永久封禁</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="!platForm.permanent" label="封禁时长" prop="time">
                <el-input type="text" v-model="platForm.time" placeholder="请输入封禁时长"></el-input>
            </el-form-item>
            <el-form-item v-if="!platForm.permanent" label="时间类型" prop="unit">
                <el-select v-model="platForm.unit" placeholder="请选择">
                    <el-option label="分钟" :value="0"></el-option>
                    <el-option label="小时" :value="1"></el-option>
                    <el-option label="天" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="封禁原因" prop="reason">
                <el-input type="textarea" :rows="3" maxlength="200" show-word-limit v-model.trim="platForm.reason"
                    placeholder="请输入封禁原因"></el-input>
            </el-form-item>
            <el-form-item label="总封禁次数">
                <el-tag type="danger">{{ banCount }}</el-tag>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submitForm('platForm')">提交</el-button>
                <el-button @click="resetForm('platForm')">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
  props: {
    banCount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      platForm: {
        time: '',
        unit: 0,
        userId: '',
        reason: '',
        permanent: false
      },
      rules: {
        time: [
          { required: true, trigger: 'change', message: '请输入封禁时长' }
        ],
        unit: [
          { required: true, trigger: 'change', message: '请选择时间类型' }
        ],
        reason: [
          { required: true, trigger: 'blur', message: '请输入封禁原因' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.platForm.permanent && !this.platForm.time) {
            this.$message.error('请输入封禁时长')
            return false
          }
          if (!this.platForm.permanent && this.platForm.unit === 0 && Number(this.platForm.time) < 5) {
            this.$message.error('封禁时长不能小于5分钟')
            return false
          }
          const submitData = {
            ...this.platForm,
            unit: this.platForm.permanent ? 3 : this.platForm.unit,
            time: this.platForm.permanent ? 0 : Number(this.platForm.time)
          }
          delete submitData.permanent
          this.$emit('platSubmit', submitData)
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style></style>
